import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

//imports of components
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import AccountNumberWithBank from "../../../_utils/CommonViewAllCard/CardSubComponent/AccountNumberWithBank";
import TextWithCTA from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithCTA";

import TextWithBank from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import { getOwnerAccBalance } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";

import { toast_position } from "../../../../redux/features/Settings/Authorization";
import TickerAnimation from "../../../_utils/TickerAnimation";
import SecondaryButton from "../../../_utils/CommonButtons/SecondaryButton";
import CommonToast from "../../../_utils/CommonToast";
import {
  errorcode,
  GlobalConfiguration,
} from "../../../../utils/configurationProvider";
import ICONS from "../../../../assets/Icons";

const ScheduleInternalTransactionMultiDetail = ({
  data,
  selectedCardIds,
  setSelectedCardIds,
  selectedSendTransactions,
  setSelectedSendTransactions,
  setIsAdditionalPopupOpen,
  setInternalAccDetailPopOpen,
  setInternalScheduleId,
  setInternalAccId,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const services = useSelector((state) => state.refreshToken.services);

  // Local state for refresh logic
  const [
    createTransactionBankRefreshLoading,
    setCreateTransactionBankRefreshLoading,
  ] = useState(false);
  const [refreshId, setRefreshId] = useState("");
  const [failedRefreshId, setFailedRefreshId] = useState([]);
  const [refreshAnimation, setRefreshAnimation] = useState("");
  const [PrevBalance, setPrevBalance] = useState(undefined);

  //functions
  const getFormattedFrequency = (txn) => {
    const startDate = txn?.transaction_start_date;
    const frequency = txn?.frequency?.toLowerCase();

    if (!startDate || !frequency) return "";

    const dateObj = new Date(startDate);
    const day = dateObj.getDate();
    const weekday = dateObj.toLocaleString("en-IN", { weekday: "short" });
    const rawMonth = dateObj.toLocaleString("en-IN", { month: "short" });
    const month = rawMonth.charAt(0).toUpperCase() + rawMonth.slice(1);

    const formatDate = (d) => `${d.getDate()} ${month}`;

    switch (frequency) {
      case "weekly":
        return `on ${weekday}`;
      case "monthly":
        return `on ${day}`;
      case "yearly":
      case "once":
        return `on ${formatDate(dateObj)}`;
      default:
        return "";
    }
  };
  const checkService =
    services?.includes("VAccountBalance") || services?.includes("Admin");

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--settled)";
      case "denied":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--settled)";
    }
  };

  const formattedFrequencyText = () => {
    const freq = data?.frequency?.toLowerCase();
    const formattedFreq =
      freq === "half_yearly"
        ? "Half yearly"
        : freq?.charAt(0).toUpperCase() + freq?.slice(1);
    const formattedDate = getFormattedFrequency(data);

    return formattedDate ? `${formattedFreq}, ${formattedDate}` : formattedFreq;
  };

  const handleRefresh = async (e, ownerAccountId, txnId, currentBalance) => {
    e.stopPropagation();
    setCreateTransactionBankRefreshLoading(true);
    setRefreshId(txnId);
    setPrevBalance(currentBalance);
    setRefreshAnimation("");

    try {
      const response = await dispatch(getOwnerAccBalance(ownerAccountId));
      toast.dismiss();
      CommonToast({
        text: "Refreshing balance",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
      });

      if (response?.payload?.status === true) {
        setRefreshAnimation(ownerAccountId);
      } else {
        setFailedRefreshId((prev) => [...prev, txnId]);
        setTimeout(() => {
          toast.dismiss();
          CommonToast({
            text: response?.payload?.response?.data?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        });
      }
    } catch (error) {
      setFailedRefreshId((prev) => [...prev, txnId]);
      CommonToast({
        text: "An error occurred",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } finally {
      setCreateTransactionBankRefreshLoading(false);

      setTimeout(() => {
        setRefreshId("");
        setRefreshAnimation("");
      }, 3000);
    }
  };

  return (
    <>
      <CardContainer
        isNoCursorRequired={true}
        isDisabled={false}
        isSelected={false}
        onClickHandler={(e) => {
          e.stopPropagation();
        }}
        isNoHoverRequired={true}
      >
        <card-body>
          <TextWithIcon
            type="Text"
            textColor="var(--text-primary)"
            fontWeight="normal"
            text={data?.scheduled_name}
            subText="Schedule name"
            iconComponentArray={[
              ...(data?.confidential_transaction === "Y"
                ? [
                    {
                      icon: "https://q2pay.in/new_assets/common/detail_page/confidential_transaction.svg",
                      title: "confidential",
                      isDisabled: false,
                    },
                  ]
                : []),
            ]}
          />

          <TextWithIcon
            type={"Amount"}
            fontWeight={"semibold"}
            text={data?.amount}
            subText={"Transaction amount"}
            textColor={"var(--settled)"}
          />

          <AccountNumberWithBank
            sourceAccNo={data?.owner_account_bank_acc_no}
            destinationAccNo={data?.internal_account_bank_acc_no}
            destinationIfsc={data?.internal_account_ifsc_code}
            sourceIfsc={data?.owner_account_ifsc_code}
          />

          <div className="relative">
            <div className="flex flex-col gap-y-gap-xs pb-padding-button-l border-b-border mx-margin-sm border-primary-bg">
              <p
                className={`text-font-sm text-text-primary w-full truncate  font-normal `}
              >
                <TickerAnimation text={formattedFrequencyText()} />
              </p>
              <div className="w-full   flex  justify-between items-center ">
                <p
                  className={`text-font-xs w-width-md text-text-secondary transform-none  font-normal`}
                >
                  Frequency
                </p>
                <div className="z-z-index-overlay absolute right-0 bottom-[1px]">
                  <SecondaryButton
                    btnText={
                      data?.internal_account_approval_status === "pending"
                        ? "Approve account"
                        : "Additional details"
                    }
                    handleFunction={(e) => {
                      e.stopPropagation();
                      if (
                        data?.internal_account_approval_status === "pending"
                      ) {
                        setInternalAccDetailPopOpen(true);
                        setInternalAccId(data?.internal_account_id);
                      } else {
                        setIsAdditionalPopupOpen("Additional details");
                        setInternalScheduleId(data?.txn_id);
                      }
                    }}
                    isDisabled={false}
                    enabledBgColor={"var(--text-primary)"}
                    enabledTextColor={"var(--primary-bg)"}
                    icon={
                      "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <TextWithBank
            text={data.owner_account_bank_acc_no}
            type={"AccountNumber"}
            subText={"Source account"}
            fontWeight={"normal"}
            textColor={"var(--text-primary)"}
            ifscCode={data?.owner_account_ifsc_code}
          />

          <TextWithIcon
            type="Amount"
            fontWeight={
              Number(data?.owner_account_balance)
                ? Number(data?.owner_account_balance) >= Number(data?.amount)
                  ? "semibold"
                  : "semibold"
                : "normal"
            }
            text={
              data?.owner_account_balance
                ? data?.owner_account_balance
                : "Not available"
            }
            subText={"Balance"}
            textColor={
              data?.owner_account_balance !== null &&
              data?.owner_account_balance !== undefined
                ? data?.owner_account_balance === "xxxx.xx" ||
                  Number.isNaN(Number(data?.owner_account_balance)) ||
                  Number(data?.owner_account_balance) >= Number(data?.amount)
                  ? "var(--settled)"
                  : "var(--failed)"
                : "var(--text-primary)"
            }
            iconComponentArray={[
              ...(function () {
                let iconUrl = "";
                let titleText = "";

                if (
                  createTransactionBankRefreshLoading &&
                  refreshId === data?.txn_id
                ) {
                  iconUrl =
                    "https://q2pay.in/new_assets/gifs/inputloader_white.gif";
                  titleText = "Balance updating";
                } else if (failedRefreshId.includes(data?.txn_id)) {
                  iconUrl =
                    "https://q2pay.in/new_assets/common/view_all/error_with_orange_circle.svg";
                  titleText = "Balance fetch failed";
                } else if (
                  !createTransactionBankRefreshLoading &&
                  refreshId === data?.txn_id &&
                  data?.owner_account_id === refreshAnimation &&
                  PrevBalance !== undefined &&
                  Number(data?.owner_account_balance) !== Number(PrevBalance)
                ) {
                  if (
                    Number(data?.owner_account_balance) > Number(PrevBalance)
                  ) {
                    iconUrl =
                      "https://q2pay.in/new_assets/gifs/arrow_up_green_gif.gif";
                    titleText = "Balance updated";
                  } else if (
                    Number(data?.owner_account_balance) < Number(PrevBalance)
                  ) {
                    iconUrl =
                      "https://q2pay.in/new_assets/gifs/arrow_down_red_gif.gif";
                    titleText = "Balance updated";
                  }
                }

                return iconUrl
                  ? [
                      {
                        icon: iconUrl,
                        title: titleText,
                        isDisabled: false,
                      },
                    ]
                  : [];
              })(),
              ...(() => {
                if (checkService)
                  return [
                    {
                      icon: "https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg",
                      title: "Refresh balance",
                      isDisabled: !(
                        services?.includes("VAccountBalance") ||
                        services?.includes("Admin")
                      ),
                      onClick: (e) => {
                        if (
                          !createTransactionBankRefreshLoading ||
                          refreshId !== data?.txn_id
                        ) {
                          if (
                            services?.includes("VAccountBalance") ||
                            services?.includes("Admin")
                          ) {
                            handleRefresh(
                              e,
                              data?.owner_account_id,
                              data?.txn_id,
                              data?.owner_account_balance,
                            );
                          } else {
                            e.stopPropagation();
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "VAccountBalance,Admin",
                              },
                            });
                          }
                        } else {
                          e.stopPropagation();
                        }
                      },
                      bgColor: "var(--primary-nav)",
                    },
                  ];
                return [];
              })(),
            ]}
          />
        </card-body>
      </CardContainer>
    </>
  );
};

export default ScheduleInternalTransactionMultiDetail;
